/* tu-motion.js -- one motion language for the things that open and close.
 * 2026-09-13, client, after the Sort dropdown: "apply the same animations to
 * filter dropdown and the nav doors, any dropdown, hamburger etc... so that
 * all buttons have an animation because the website today doesn't have
 * animations."
 *
 * The Sort menu set the vocabulary (assets/tu-system.css, "tu-sort"): a
 * panel fades in and settles 6px, its rows slide in 30ms apart, a chevron
 * turns. This file gives the same to the two <details> controls that could
 * not animate on their own, because a <details> shows its content the
 * instant `open` flips:
 *
 *   .tu-filters__sheet  the Filter dropdown on collection and search pages.
 *                       Opening: set `open`, next frame add `is-anim` -- CSS
 *                       fades the panel and staggers the filter groups.
 *                       Closing: drop `is-anim`, let the fade run, then clear
 *                       `open`. Also closes on a click outside and on Escape
 *                       (the CSS comment promised that; nothing did it).
 *   .tu-filter          each filter group inside it. Its body's height is
 *                       animated with the Web Animations API from 0 to its
 *                       natural height, and back before `open` is cleared.
 *
 * prefers-reduced-motion: the native instant behaviour, untouched. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // The filter panel's hidden start state lives under html.tu-motion, so a
  // page without this script (or with reduced motion) shows it plainly.
  if (!reduced) document.documentElement.classList.add('tu-motion');
  var SHEET = '.tu-filters__sheet';
  var GROUP = '.tu-filter';
  var FADE = 200;

  function sheetOpen(d) {
    d.open = true;
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-anim'); }); });
  }
  function sheetClose(d) {
    if (!d.open) return;
    if (!d.classList.contains('is-anim')) { d.open = false; return; }
    d.classList.remove('is-anim');
    setTimeout(function () { if (!d.classList.contains('is-anim')) d.open = false; }, FADE);
  }

  function groupToggle(d) {
    var body = d.querySelector(':scope > summary + *');
    if (!body || d.dataset.tuBusy) { d.open = !d.open; return; }
    d.dataset.tuBusy = '1';
    var done = function () { delete d.dataset.tuBusy; body.style.overflow = ''; body.style.height = ''; };
    if (!d.open) {
      d.open = true;
      var h = body.getBoundingClientRect().height;
      body.style.overflow = 'hidden';
      body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: FADE, easing: 'ease' })
        .addEventListener('finish', done);
    } else {
      var h0 = body.getBoundingClientRect().height;
      body.style.overflow = 'hidden';
      var a = body.animate([{ height: h0 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: FADE, easing: 'ease' });
      a.addEventListener('finish', function () { d.open = false; done(); });
    }
  }

  document.addEventListener('click', function (e) {
    var sum = e.target.closest('summary');
    if (sum) {
      var d = sum.parentElement;
      if (d.matches(SHEET)) {
        if (reduced) return;
        e.preventDefault();
        d.open ? sheetClose(d) : sheetOpen(d);
        return;
      }
      if (d.matches(GROUP)) {
        if (reduced) return;
        e.preventDefault();
        groupToggle(d);
        return;
      }
    }
    // outside the sheet: close it
    if (!e.target.closest(SHEET)) {
      document.querySelectorAll(SHEET + '[open]').forEach(function (d) { reduced ? (d.open = false) : sheetClose(d); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(SHEET + '[open]').forEach(function (d) {
      reduced ? (d.open = false) : sheetClose(d);
      var s = d.querySelector(':scope > summary'); if (s) s.focus();
    });
  });
})();
